/** @jsx jsx */
import Editing from 'assets/key-feature/editing.svg';
import Speed from 'assets/key-feature/speed.svg';
import Vector from 'assets/key-feature/vector.svg';
import FeatureCardColumn from 'components/feature-card-column.js';
import { Container, Grid, jsx } from 'theme-ui';
import SectionHeader from '../components/section-header';

const data = [
  {
    id: 1,
    imgSrc: Vector,
    altText: 'HARDWARE AND EMBEDDED SYSTEM DEVICE',
    title: 'HARDWARE AND EMBEDDED SYSTEM DEVICE',
    sub: [
      'Research and Development of loT and M2M Devices',
      'Automation, Sensor, Monitoring, Smart City'
    ]
  },
  {
    id: 2,
    imgSrc: Editing,
    altText: 'SOFTWARE AND SOLUTION SYSTEM',
    title: 'SOFTWARE AND SOLUTION SYSTEM',
    sub: [
      'Web and Desktop Application',
      'Mobile Application Development'
    ]
  },
  {
    id: 3,
    imgSrc: Speed,
    altText: 'TELECOM SERVICES',
    title: 'TELECOM SERVICES',
    sub: [
      'ICT Installation and Maintenance',
      'Fiber Optic Configuration and Installation',
      'Network Optimization'
    ]
  },
];

export default function KeyFeature() {
  return (
    <section sx={{ variant: 'section.keyFeature' }} id="expertise">
      <Container>
        <SectionHeader
          slogan="Our Expertise"
          title="Get Closer to Our Expertise"
        />

        <Grid sx={styles.grid}>
          {data.map((item) => (
            <div>
              <FeatureCardColumn
                key={item.id}
                src={item.imgSrc}
                alt={item.title}
                title={item.title}
              />

              <ul variant="heroSecondary">
                {item.sub.map((x) => (
                  <li>{x}</li>
                ))}
              </ul>
            </div>
          ))}
        </Grid>
      </Container>
    </section>
  );
}

const styles = {
  grid: {
    px: [0, null, null, '0px', null, '80px'],
    pt: [0, null, null, null, null, null, null, 3],
    gridGap: ['35px 0', null, '40px 0'],
    gridTemplateColumns: [
      'repeat(1,1fr)',
      null,
      'repeat(3,1fr)',
      null,
      'repeat(3,1fr)',
    ],
    width: ['100%', '80%', '100%'],
    mx: 'auto',
    '& > div': {
      px: [0, '15px', 'null', '25px', null, '30px', '40px', '60px'],
    },
  },
};
